import {Injectable} from '@angular/core';
import {DefaultDataServiceConfig, Logger} from '@ngrx/data';
import {HttpClient} from '@angular/common/http';
import {AbstractDataServiceV2} from 'src/app/modules/core/service/v2/dataservice/abstractDataServiceV2';
import {CustomizeHttpUrlGenerator} from 'src/app/store/core/url/customizeHttpUrlGenerator';
import {PaymentCardReaderModel} from '../../../api/entity/paymentCardReader.model';
import {PaymentCardReaderConverter} from '../../../api/entity/converter/paymentCardReader.converter';

@Injectable({
    providedIn: 'root'
})
export class PaymentCardReaderDataService extends AbstractDataServiceV2<PaymentCardReaderModel, PaymentCardReaderConverter> {
    constructor(
        http: HttpClient,
        httpUrlGenerator: CustomizeHttpUrlGenerator,
        logger: Logger,
        config: DefaultDataServiceConfig,
        converter: PaymentCardReaderConverter) {
        super('PaymentCardReader', http, httpUrlGenerator, logger, config, converter);
    }
}
